import { categories } from '@/mocks/categories';

export default function LiveDataShowcase() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900">
              最新开奖数据
            </h2>
            <p className="mt-1 text-sm text-foreground-500">实时更新，准确可靠</p>
          </div>
          <div className="hidden sm:flex items-center gap-2 text-sm text-foreground-400">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
            数据实时更新中
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <div
              key={cat.slug}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-colors"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg">
                    <i className={`${cat.icon} text-primary-600 text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">{cat.name}</h3>
                    <p className="text-xs text-foreground-400">{cat.latestDraw}</p>
                  </div>
                </div>
                <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2 py-1 rounded-md">
                  最新
                </span>
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                {cat.latestNumbers.map((num, idx) => (
                  <span
                    key={idx}
                    className={`w-9 h-9 flex items-center justify-center rounded-full text-sm font-bold ${
                      cat.slug === 'shuangseqiu' && idx === cat.latestNumbers.length - 1
                        ? 'bg-primary-500 text-background-50'
                        : cat.slug === 'daletou' && idx >= cat.latestNumbers.length - 1
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-100 text-foreground-800'
                    }`}
                  >
                    {num}
                  </span>
                ))}
              </div>
              {cat.prize && (
                <p className="mt-3 text-xs text-foreground-400">
                  当前奖池：<span className="text-accent-600 font-semibold">{cat.prize}元</span>
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}